import React from "react";
import { domainTheme, type DomainCode } from "@/lib/domainTheme";
import { ControlHover } from "@/components/ui/ControlHover";

export function ControlsPills({
  controls,
  currentDomain,
  onHoverControl,
}: {
  controls: string[];
  currentDomain?: string;
  onHoverControl?: (code: string | null) => void;
}) {
  if (!Array.isArray(controls) || controls.length === 0) return null;

  const validDomains = ["GV", "ID", "PR", "DE", "RS", "RC"] as const;
  const domainKey =
    currentDomain && (validDomains as readonly string[]).includes(currentDomain)
      ? (currentDomain as DomainCode)
      : null;

  const pillClasses = domainKey
    ? domainTheme[domainKey].pill
    : "bg-slate-100 text-slate-700 ring-slate-200";

  return (
    <div className="mt-3 max-w-full overflow-hidden">
      <div className="mb-1 text-xs font-medium uppercase tracking-wide text-muted-foreground">
        Mapped Controls
      </div>
      <div className="flex flex-wrap gap-2 max-w-full">
        {controls.map((code) => (
          <ControlHover
            key={code}
            code={code}
            className={`ring-1 ring-inset ${pillClasses}`}
          >
            {code}
          </ControlHover>
        ))}
      </div>
    </div>
  );
}
